module.exports = __webpack_public_path__ + "media/images/nist_logo_reverse-86a7f19f71f55bdf548d84db1924bae8.png";